import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const AlertBell14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M7.00015 0.249939C4.3768 0.249939 2.25015 2.37659 2.25015 4.99994V6.28884C2.25015 7.15022 1.87328 7.83815 1.41258 8.52921C0.637263 9.69218 1.47095 11.2499 2.86867 11.2499H4.75C4.75 12.5586 5.58195 13.75 7 13.75C8.41805 13.75 9.25 12.5586 9.25 11.2499H11.1316C12.5293 11.2499 13.363 9.69219 12.5877 8.52921C12.127 7.83815 11.7501 7.15022 11.7501 6.28884V4.99994C11.7501 2.37659 9.6235 0.249939 7.00015 0.249939ZM7.75 11.2499H6.25C6.25 11.7313 6.41089 12.25 7 12.25C7.58911 12.25 7.75 11.7313 7.75 11.2499ZM3.75015 4.99994C3.75015 3.20501 5.20522 1.74994 7.00015 1.74994C8.79507 1.74994 10.2501 3.20501 10.2501 4.99994V6.28884C10.2501 7.44987 10.7131 8.42138 11.3396 9.36126C11.4504 9.5274 11.3313 9.74994 11.1316 9.74994H2.86867C2.66899 9.74994 2.54989 9.5274 2.66065 9.36126C3.28724 8.42138 3.75015 7.44987 3.75015 6.28884V4.99994Z'
      fill='currentColor'
    />
  </Svg>
);

AlertBell14.displayName = 'AlertBell14';
export default AlertBell14;
